import useSWR from 'hooks/useSWR';
import { CommunityInviteDetails } from 'types/company/community';
import { useSWRResource } from 'util/resource/useSWRResource';
import { communityAPIUrls } from './communitiesApi';

interface CommunityInviteParams {
  communityCode?: UUID;
  communityId?: number;
}

export const communityInviteKey = ({ communityCode, communityId }: CommunityInviteParams) => {
  const param = communityCode ?? communityId;
  return param ? communityAPIUrls.invitations.get(param) : undefined;
};

export const useCommunityInvite = (params: CommunityInviteParams) => {
  const swrResult = useSWR<CommunityInviteDetails>(communityInviteKey(params));
  return useSWRResource(swrResult);
};
